/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import * as ActionTypes from '../constants/ActionTypes';

const defaultImportDataState = {
	showStartImportDialog: false,
	importData: null
};

export default function importDataReducer(state = defaultImportDataState, action) {
	switch (action.type) {
		case ActionTypes.SHOW_START_IMPORT:
			return {
				...state,
				showStartImportDialog: true
			};
		case ActionTypes.SHOW_IMPORT:
			return {
				...state,
				importData: action.data
			};
		case ActionTypes.HIDE_IMPORT_DIALOG:
			return defaultImportDataState;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/importReducer.js